import { DatePickerComponent } from "./DatePicker";
import { Controlled } from "./Controlled";
import { Element } from "./Element";
import { Label } from "./Label";
import { Root } from "./Root";
import { Error } from "./Error";

export const Input = {
    Root: Root,
    Element: Element,
    Label: Label,
    Error: Error,
    Controlled: Controlled,
    DatePicker: DatePickerComponent
}